import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface ApiLogEntry {
  id: number;
  timestamp: string;
  method: string;
  url: string;
  payload: unknown | null;
  response: unknown | null;
  code: number | null;
}

@Injectable({
  providedIn: 'root'
})
export class ApiLogService {
  private entries: ApiLogEntry[] = [];
  private entries$ = new BehaviorSubject<ApiLogEntry[]>([]);
  private nextId = 1;

  createEntry(initial: Omit<ApiLogEntry, 'id'>): ApiLogEntry {
    const entry: ApiLogEntry = { id: this.nextId++, ...initial };
    this.entries.push(entry);
    this.entries$.next([...this.entries]);
    return entry;
  }

  updateEntry(id: number, patch: Partial<ApiLogEntry>): void {
    const index = this.entries.findIndex(entry => entry.id === id);
    if (index < 0) {
      return;
    }
    this.entries[index] = { ...this.entries[index], ...patch };
    this.entries$.next([...this.entries]);
  }

  getEntries(): ApiLogEntry[] {
    return [...this.entries];
  }

  getEntries$(): Observable<ApiLogEntry[]> {
    return this.entries$.asObservable();
  }

  clear(): void {
    this.entries = [];
    this.entries$.next([]);
  }
}
